/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  import { G3W_FID }                                 from 'g3w-constants';
  import DataRouterService                           from 'services/data';
  import Node                                        from 'components/GlobalTabsNode.vue';
  import GUI                                         from 'services/gui';
  import { getAlphanumericPropertiesFromFeature }    from 'utils/getAlphanumericPropertiesFromFeature';
  import { getUniqueDomId }                          from 'utils/getUniqueDomId';
  import { noop }                                    from 'utils/noop';

  /**
   * Convert feature to form Data for expression/expression_eval request
   */
  function getFormData(feature, contenttype) {
    let _feature = feature;

    if ('editing' !== contenttype) {
      delete feature.attributes.geometry;

      _feature   = new ol.Feature(feature.geometry);
      const properties = {};

      getAlphanumericPropertiesFromFeature(feature.attributes)
        .filter(p => G3W_FID !== p)
        .forEach(p => properties[p] = feature.attributes[p]);
      _feature.setProperties(properties);
      _feature.setId(feature.id || feature.attributes[G3W_FID]);
    }

    return (new ol.format.GeoJSON()).writeFeatureObject(_feature);
  }

  const __vue_script__ = {
    name: "tabs",
    props: {
      group: {
        type:    Boolean,
        default: false
      },
      contenttype: {
        default: 'query'//or editing
      },
      layerid:{
        required: true
      },
      tabs: {
        required: true
      },
      feature: {
        required: true
      },
      fields: {
        required: true
      },
      addToValidate: {
        type:    Function,
        default: noop
      },
      removeToValidate: {
        type:    Function,
        default: noop
      },
      changeInput: {
        type:    Function,
        default: noop
      },
      showRelationByField: {
        type:    Boolean,
        default: true
      },
      handleRelation: {
        type:     Function,
        default: ({ relation, layerId, feature } = {}) => GUI.getService('queryresults').showRelation({relation, layerId, feature})
      }
    },
    data() {
      return {
        ids : []
      }
    },
    computed: {
      required_fields() {
        return 'editing' ===  this.contenttype && this.fields.filter(f => f.validate.required).map(f => f.name);
      },
      show() {
        return this.tabs.reduce((a, t) => a || (t.visible === undefined || !!t.visible), false);
      }
    },
    methods: {
      /**
       * ORIGINAL SOURCE: src/app/core/expression/tabservice.js@3.8.6
       */
      async setVisibility(tab) {
        tab.visible = await DataRouterService
          .getData(
            'expression:expression_eval',
              {
              inputs: {
                qgs_layer_id: this.layerid,
                form_data:    getFormData(this.feature || {}, this.contenttype),
                expression:   tab.visibility_expression.expression,
                formatter:    ('query' === this.contenttype ? 1 : 0),
              },
              outputs: false,
            }
          );
      },
      // method to set required tab for editing
      setEditingRequireTab(obj) {
        if (undefined === obj.nodes) {
          return this.required_fields.includes(obj.field_name);
        } else {
          return !!obj.nodes.find(n => this.setEditingRequireTab(n));
        }
      },
      getField(fieldName) {
        return this.fields.find(f => fieldName === f.name);
      },

      /**
       * Mimics <details> tag behaviour
       * 
       * @since 3.10.0 
       */
      toggleGroup(e) {
        const wrapper = e.target.closest('.tabs-wrapper');
        wrapper.classList.toggle('collapsed');
      },

    },
    components: {
      Node
    },
    async created() {
      this.unwatch = [];
      this.tabs.forEach(async (tab , i) => {
        if (tab.visibility_expression) {
          if (undefined === tab.visible) { this.$set(tab, 'visible', 0) }
          await this.setVisibility(tab);
        }
        if ('editing' === this.contenttype) {
          if (undefined === tab.required) {
            tab.required = this.setEditingRequireTab(tab);
          }
          if (tab.visibility_expression) {
            tab.visibility_expression
              .referenced_columns
              .forEach(c => {
                const field = this.fields.find(f => c === f.name);
                this.unwatch.push(
                  this.$watch(() => field.value,
                    async () => {
                      //need to wait that form set new value of change field to feature
                      await this.$nextTick();
                      await this.setVisibility(tab);
                    })
                )
              })
          }
        }
        this.ids.push(`tab_${getUniqueDomId()}`);
      });

      this.root_tabs = [];
      if (!this.group) {
        const nodes = [];
        this.tabs.forEach(tab_node => {
          if (tab_node.nodes) { nodes.push(tab_node) }
          else {
            if (nodes.length) {
              this.root_tabs.push([...nodes]);
              nodes.splice(0);
            }
            this.root_tabs.push({nodes:[tab_node]});
          }
        });
        if (nodes.length) {
          this.root_tabs.push(nodes)
        }
      } else {
        this.root_tabs = [this.tabs];
      }
    },
    beforeDestroy() {
      this.unwatch.forEach(unwatch => unwatch());
      this.unwatch = null;
    }
  }

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"tabs-wrapper"},[_vm._l((_vm.root_tabs),function(root_tab,i){return [(Array.isArray(root_tab))?[_c('ul',{staticClass:"formquerytabs nav nav-tabs"},[_vm._l((root_tab),function(tab,index){return [(tab.visible === undefined || tab.visible)?_c('li',{class:{active: index === 0}},[_c('a',{staticClass:"tab_a",class:{'mobile': _vm.isMobile(), 'group-title': _vm.group},style:({fontSize: _vm.isMobile() ? '1.0em': ((_vm.group ? '1.1': '1.2') + "em")}),attrs:{"data-toggle":"tab","href":("#" + (_vm.ids[index]))},on:{"click":function($event){_vm.group && _vm.toggleGroup($event)}}},[_vm._v("\n               "+_vm._s(tab.name)+" "),(_vm.contenttype === 'editing' && tab.required)?_c('span',{staticStyle:{"padding-left":"3px","font-size":"1.1em"}},[_vm._v("*")]):_vm._e()])]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"tab-content",class:{editing: 'editing' === _vm.contenttype }},[_vm._l((root_tab),function(tab,index){return [(undefined === tab.visible || tab.visible)?_c('div',{staticClass:"tab-pane fade",class:{'in active': index === 0},attrs:{"id":_vm.ids[index]}},[_c('node',{attrs:{"showRelationByField":_vm.showRelationByField,"handleRelation":_vm.handleRelation,"feature":_vm.feature,"layerid":_vm.layerid,"contenttype":_vm.contenttype,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"changeInput":_vm.changeInput,"fields":_vm.fields,"showTitle":false,"node":tab}})],1):_vm._e()]})],2)]:_c('node',{class:[(i % 2 ) ? 'odd': 'even'],attrs:{"showRelationByField":_vm.showRelationByField,"handleRelation":_vm.handleRelation,"feature":_vm.feature,"layerid":_vm.layerid,"contenttype":_vm.contenttype,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"changeInput":_vm.changeInput,"fields":_vm.fields,"showTitle":false,"node":root_tab}})]})],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1cf08cba_0", { source: ".formquerytabs.nav-tabs>li[data-v-1cf08cba]{margin-right:3px}.formquerytabs.nav-tabs>li[data-v-1cf08cba]:last-child{margin-right:0}.formquerytabs.nav-tabs li:not(.active)>a[data-v-1cf08cba]{color:var(--skin-color);background-color:hsl(from var(--skin-color) h s calc(l + 48))!important;border:1px solid hsl(from var(--skin-color) h s calc(l + 30));margin:0 3px 3px 0;border-bottom:0!important}.formquerytabs.nav-tabs li>a[data-v-1cf08cba]{color:var(--skin-color)}.formquerytabs.nav-tabs li a.tab_a.group-title[data-v-1cf08cba]{background-color:hsl(from var(--skin-color) h s calc(l + 20))!important}.formquerytabs.nav-tabs .nav-tabs>li.active>a[data-v-1cf08cba]:hover,.formquerytabs.nav-tabs li.active>a[data-v-1cf08cba],.formquerytabs.nav-tabs li.active>a[data-v-1cf08cba]:focus{background-color:var(--skin-color)!important;color:#fff}.skin-green .formquerytabs.nav-tabs li:not(.active)>a[data-v-1cf08cba]{background-color:#e4ffcb!important}.skin-green .formquerytabs.nav-tabs li a.tab_a.group-title[data-v-1cf08cba]{background-color:rgba(61,166,90,.85)!important}.skin-red .formquerytabs.nav-tabs li:not(.active)>a[data-v-1cf08cba]{background-color:hsl(from var(--skin-danger) h s calc(l + 40))!important}.skin-yellow .formquerytabs.nav-tabs li:not(.active)>a[data-v-1cf08cba]{background-color:#fefcfa!important;border:1px solid var(--skin-warning-d40)}.formquerytabs[data-v-1cf08cba]{overflow:hidden!important;display:flex;flex-wrap:wrap}.formquerytabs>li[data-v-1cf08cba]{flex:1;display:flex}.formquerytabs>li>a[data-v-1cf08cba]{font-weight:700;flex:1}.nav-tabs>li>a.mobile[data-v-1cf08cba]{padding:5px 10px}.tab_a[data-v-1cf08cba]{padding:5px;margin-right:0!important;border-bottom:0;margin-bottom:3px;border-radius:3px 3px 0 0}.formquerytabs li a.tab_a.group-title[data-v-1cf08cba]{color:inherit!important;font-weight:500;font-size:1em!important;padding:.25em;cursor:pointer}.tabs-wrapper>.formquerytabs li a.tab_a.group-title[data-v-1cf08cba]:before{content:'▾'}.tabs-wrapper.collapsed>.formquerytabs li a.tab_a.group-title[data-v-1cf08cba]:before{content:'▸'}.tabs-wrapper.collapsed>.formquerytabs+.tab-content[data-v-1cf08cba]{display:none}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-1cf08cba"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "GlobalTabs.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__